<template>
  <div class="resister-content">
    <!-- <div class="hearder"> -->
    <!-- <a class="cursor" @click="util.topage('home')"><img src="@/assets/images/icon/home_icon_251286.png"/></a> -->
    <!-- <a class="cursor"><img src="@/assets/images/icon/smiled_emoji_icon_250933.png" /></a> -->
    <!-- </div> -->
    <div class="btcCenter">
      <img src="@/assets/images/base/logo.png" />
      <!-- <p>Thomas<span style="color: #44cbb3;">Wang</span></p> -->
      <!-- <p>Your Name</p> -->
      <!-- <p class="p1">data Platform</p> -->
    </div>
    <div class="box">
      <ul>
        <li>
          <div class="icon-input"><img src="@/assets/images/icon/user_icon_251290.png" /></div>
          <input type="text" v-model="username" v-on:input="phone_input" placeholder="Your Username" />
        </li>
        <li>
          <div class="icon-input"><img src="@/assets/images/icon/lock_icon_251307.png" /></div>
          <div class="icon-input eyeimg cursor" @click="fristeye"><img :src="fristeyepic" /></div>
          <input :type="fristtype" v-model="password" placeholder="Password Length 6~30" @keyup.enter="submitbtn" />
        </li>
        <li>
          <button class="btn-submit" @click="submitbtn">Login</button>
        </li>
        <li>
          <div class="btn-other"><span>No Username?</span>
            <span style="color:#0860a8;font-size: 0.32rem;" @click="util.topage('register')">Register Now</span>
          </div>
        </li>
        <ul class="service_list">
          <!-- <li class="service_item" v-if="telegram_url.length > 1"  @click="to_service('telegram')">
            <img src="@/assets/images/base/img_tg.png" alt="">
          </li> -->
          <li class="service_item" v-if="telegram_url.length > 1">
          <!-- <a href="https://t.me/CustomerSupportTeaV_001" target="_blank"> -->
            <a :href="telegram_url" target="_blank">
            <img src="@/assets/images/base/img_tg.png" alt="">
          </a>
          </li>
          <li class="service_item" v-if="whatsapp_url.length > 1"  @click="to_service('whatsapp')">
            <img src="@/assets/images/base/img_wa.png" alt="">
          </li>
        </ul>
        <div class="banquan" @click="callService">
          <div>All Rights Reserved</div>
          <div>&copy;2008-2026</div>
        </div>
      </ul>
    </div>
    <van-loading v-show="!cheackpass" size="50px" color="#1989fa" vertical />
  </div>
</template>
<script>
import Vue from "vue";
import { Loading } from "vant";
Vue.use(Loading);
/*global mui*/
export default {
  data() {
    return {
      username: "",
      password: "",
      fristtype: "password",
      fristeyepic: require("@/assets/images/icon/hide_eye_icon_251206.png"),
      cheackpass: true,
      telegram_url: '',
      whatsapp_url: ''
    };
  },
  methods: {
    to_service(url) {
      if(url == 'telegram') {
        window.location.href = this.telegram_url
      } else {
        window.location.href = this.whatsapp_url
      }
    },
    get_service_url() {
      this.axios.get(this.api.api_findConfigs, {
        params: {
          names: "telegram,whatsapp",
        },
      }).then((res) => {
        this.telegram_url = res.data.data.telegram
        this.whatsapp_url = res.data.data.whatsapp
      }).catch((err) => {
          console.log(err);
        });
    },
    trim(str) {
      return str.replace(/^\s+|\s+$/g, "");
    },
    phone_input() {
      this.username = this.trim(this.username)
    },
    fristeye() {
      if (this.fristtype == "password") {
        this.fristtype = "text";
        this.fristeyepic = require("@/assets/images/icon/show_eye_icon_251206.png");
      } else {
        this.fristtype = "password";
        this.fristeyepic = require("@/assets/images/icon/hide_eye_icon_251206.png");
      }
    },
    submitbtn() {
      if (this.username.length < 1) {
        mui.alert("Username cannot be empty");
      } else if (!this.password) {
        mui.alert("Password cannot be empty");
      } else if (this.cheackpass) {
        this.submitLogin();
      }
    },
    submitLogin() {
      this.cheackpass = false;
      let params = {
        userName: this.username,
        password: this.md5.md5_hex_utf8(this.password)
      };
      this.util.setDnValue(params);
      this.axios.post(this.api.api_userLogin, this.util.encodeSearchParams(params)).then((res) => {
        this.cheackpass = true;
        if (res.data.code == 0) {
          let nowtime = new Date();
          let newData = [res.data.data].map(item => {
            return {
              id: item.id,
              user_id: item.user_id,
              phone: item.phone,
              login_name: item.login_name,
              nick_name: item.nick_name,
              status: item.status,
              level: item.level,
              has_pay_password: item.has_pay_password,
              sex: item.sex,
              email: item.email,
              ico_picture_img: require('@/assets/images/avater/' + item.ico_picture + '.png'),
              ico_picture: item.ico_picture,
              money: item.money,
              frozen_money: item.frozen_money,
              integral: item.integral,
              remark: item.remark,
              sign_days: item.sign_days,
              last_sign_time: item.last_sign_time,
              is_sign: item.is_sign,
              token: item.token,
              invite_code: parseInt(item.user_id) + 100000,
              nowtime: nowtime
            };
          });
          sessionStorage.setItem("user", JSON.stringify(newData[0]));
          this.util.user = newData[0];
          this.$router.push('home');
        } else {
          mui.alert(res.data.message);
        }
      }).catch(() => {
          this.cheackpass = true;
          mui.alert("Your current network is unstable. Please optimize the network.");
        });
    },
    callService() {
      // this.axios.get(this.api.api_findOneConfigByKeyName, {
      // 	params: { key_name: "customer_service" }
      // }).then((res) => {
      // 	if (res.data.code == 0) {
      //     window.location = res.data.data.key_value;
      // 	}
      // }).catch((err) => {
      // 	console.log(err);
      // });
    }
  },
  mounted() {
    this.get_service_url()
  },
  activated() {
    this.username = "";
    this.password = "";
  }
};
</script>
<style lang="scss" scoped>
@import "@/assets/styles/login.scss";
</style>